import { useCallback, useState } from 'react';

type AssetPreviewState = {
  previewUrl: string | null;
  previewName: string;
};

type AssetPreviewActions = {
  openPreview: (url: string, name: string) => void;
  closePreview: () => void;
};

export const useAssetPreview = (): AssetPreviewState & AssetPreviewActions => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [previewName, setPreviewName] = useState('');

  const openPreview = useCallback((url: string, name: string) => {
    setPreviewUrl(url);
    setPreviewName(name);
  }, []);

  const closePreview = useCallback(() => {
    setPreviewUrl(null);
    setPreviewName('');
  }, []);

  return {
    previewUrl,
    previewName,
    openPreview,
    closePreview,
  };
};
